import React from 'react';
import Header from './header';
import Navigation from './navigation';
import NavButton from './nav-button';

const Layout = ({ children }) => {
    return (
        <div>
            <Header />
            <div className="layout">
                <div className="left-panel">{children}</div>
                <div className="right-panel"><Navigation /></div>
            </div>
            <NavButton />
        </div>)
}

export default Layout;